// extracted by mini-css-extract-plugin
export default {"container":"ICYtdRCxs2CVWhXAhSoU","text":"E2AVG3zDkV1NQhGLU_4Q"};